module.exports = __webpack_public_path__ + "static/media/thailand.e7f18a54.svg";